import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { HealthScreeningService } from "@shared/services/legacy/health-screening.service";
import { PulseSurveyService } from "@shared/services/legacy/pulse-survey.service";
import { forkJoin, map } from "rxjs";
import { UserService } from "src/services/user.service";

export const hasDoneMultipleThings: CanActivateFn = () => {
	const router = inject(Router);
	const healthScreeningService = inject(HealthScreeningService);
	const pulseSurveyService = inject(PulseSurveyService);
	const userService = inject(UserService);

	return forkJoin({
		healthScreening: healthScreeningService.getHealthScreeningSurvey(),
		historicPulseSurveys: pulseSurveyService.getTypesOfHistoricPulseSurveys(),
		activeSurveys: userService.getActiveSurveys(),
	}).pipe(
		map(({ healthScreening, historicPulseSurveys, activeSurveys }) => {
			if (historicPulseSurveys.length || activeSurveys.length) {
				return true;
			} else if (healthScreening) {
				router.navigate(["/health-screening"]);
				return false;
			}
			return false;
		}),
	);
};
